import { mapValue } from "Utilities";
import getCssVarValue from "./function_get-css-var-value";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    var registered = false;
    var blh;

    function init() {
        jdmn.log("function_custom-animations.js initialized", "green");

        blh = getCssVarValue("--blh");

        if (!registered) {
            gsap.registerPlugin(ScrollTrigger);
            registered = true;
        }
        /**
         * Hero Overlay
         */
        (function () {
            var selector = "#hero .overlay";

            if (!$(selector).length) return;

            $(selector).each(function () {
                var $instance = $(this);

                gsap.to($instance[0], {
                    "--alpha": 0.8,
                    scrollTrigger: {
                        trigger: $instance.next()[0],
                        start: "top bottom",
                        end: "top center",
                        scrub: 0.5,
                    },
                });
            });
        })();

        /**
         * Radius Tween
         */
        (function () {
            var selector = ".radius-tween";

            if (!$(selector).length) return;

            $(selector).each(function () {
                var $instance = $(this);

                gsap.to($instance[0], {
                    borderRadius: "0",
                    scrollTrigger: {
                        trigger: $instance[0],
                        start: `top top+=${blh * 2}`,
                        end: "top top",
                        scrub: 0.5,
                    },
                });
            });
        })();
    }

    $(document).ready(init);
})();
